import { observable } from 'mobx';
import BasePollableLoginStore, { Service } from './BasePollableLoginStore';
import RootStore from './RootStore';

export interface MobileIdLoginCredentials {
  mobileNumber: string;
  personalCode: string;
}

export default class MobileIdLoginStore extends BasePollableLoginStore {
  @observable accessor mobileIdLoginCredentials: MobileIdLoginCredentials = {
    mobileNumber: '',
    personalCode: ''
  };

  constructor(props: RootStore) {
    super(props);
  }

  get loginCredentials(): MobileIdLoginCredentials {
    return this.mobileIdLoginCredentials;
  }

  get service(): Service {
    return 'mobile-id';
  }
}
